import styled, { css } from 'styled-components'
import { colors, derivedColors } from '../../const'

const alignToFlex = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
}

const alignToText = {
  left: 'left',
  center: 'center',
  right: 'right'
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const HeaderBlock = styled.div`
  margin-bottom: 18px;
  padding: 2px 0 8px;
`

export const Title = styled.h2`
  color: ${colors.textPrimary};
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.02em;
  margin: 0;
`

export const Subtitle = styled.p`
  color: ${colors.textSecondary};
  font-size: clamp(1rem, 1.1vw, 1.2rem);
  line-height: 1.4;
  margin: 10px 0 0;
`

export const TableScroll = styled.div`
  overflow-x: auto;
  width: 100%;
`

export const TableFrame = styled.div(
  ({ minWidth }) => css`
    min-width: ${minWidth || '1120px'};
    width: 100%;
  `
)

export const TableHeader = styled.div(
  ({ gridTemplateColumns }) => css`
    border-bottom: 1px solid ${colors.borderSubtle};
    display: grid;
    grid-template-columns: ${gridTemplateColumns};
    width: 100%;
  `
)

export const HeaderCell = styled.div(
  ({ align = 'left' }) => css`
    align-items: center;
    display: flex;
    justify-content: ${alignToFlex[align] || alignToFlex.left};
    min-height: 60px;
    padding: 0 14px 12px;
    text-align: ${alignToText[align] || alignToText.left};
  `
)

export const HeaderButton = styled.button(
  ({ align = 'left' }) => css`
    align-items: center;
    background: transparent;
    border: none;
    color: ${colors.textSecondary};
    cursor: pointer;
    display: inline-flex;
    font-size: 1.04rem;
    font-weight: 700;
    gap: 8px;
    justify-content: ${alignToFlex[align] || alignToFlex.left};
    padding: 0;
    text-align: ${alignToText[align] || alignToText.left};
    width: 100%;

    &:hover {
      color: ${colors.textPrimary};
    }
  `
)

export const HeaderLabel = styled.span`
  color: ${colors.textSecondary};
  display: inline-flex;
  font-size: 1.04rem;
  font-weight: 700;
  line-height: 1.25;
`

export const SortIconWrapper = styled.span`
  align-items: center;
  color: ${derivedColors.attenuated};
  display: inline-flex;
  line-height: 0;
`

export const TableBody = styled.div`
  width: 100%;
`

export const BodyRow = styled.div(
  ({ gridTemplateColumns, rowBackground }) => css`
    background-color: ${rowBackground || 'transparent'};
    border-bottom: 1px solid ${colors.borderSubtle};
    display: grid;
    grid-template-columns: ${gridTemplateColumns};
    width: 100%;
  `
)

export const BodyCell = styled.div(
  ({ align = 'left' }) => css`
    align-items: center;
    color: ${colors.textSecondary};
    display: flex;
    font-size: 1.08rem;
    font-weight: 500;
    justify-content: ${alignToFlex[align] || alignToFlex.left};
    line-height: 1.35;
    min-height: 78px;
    padding: 14px;
    text-align: ${alignToText[align] || alignToText.left};
  `
)

export const EmptyRow = styled.div`
  color: ${colors.textSecondary};
  font-size: 1rem;
  padding: 24px 8px;
  text-align: center;
`
